export default __webpack_public_path__ + "static/media/wellness-prevention-family-4.4a41b88a.svg";